
export const TOP_FILTER_EXTENDED_TIN = 'extended-tins/top-filter';
